import React from 'react';
import { Fab, Box, Fade } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../../logo512.png';
import { useAuth } from '../../../hooks/useAuth';

export default function HomeFab({ disabled = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { role } = useAuth();

  const handleClick = () => {
    navigate('/dashboard'); // redirect to /dashboard
  };

  // Control visibility: hide if on dashboard or disabled
  const visible = !(location.pathname === '/dashboard' || disabled) && role !== 'guest';

  return (
    <Fade in={visible} timeout={500} mountOnEnter unmountOnExit>
      <Fab
        onClick={handleClick}
        color="primary"
        aria-label="home"
        sx={{
          position: 'fixed',
          bottom: -10,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10000,
          width: 52,
          height: 52,
          minHeight: 52,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Home"
          sx={{
            width: 48,
            height: 48,
            objectFit: 'contain',
          }}
        />
      </Fab>
    </Fade>
  );
}
